import {createStore as _createStore, applyMiddleware, compose} from 'redux';
import createMiddleware from './middleware/clientMiddleware';
import urlMiddleware from './middleware/urlMiddleware';
import EventEmitter from '../EventEmitter';
import immutable from 'immutable';
import {load as dbInfoLoad} from './modules/dbinfo';
// import transitionMiddleware from './middleware/transitionMiddleware';
import persistLocalState from 'redux-localstorage';
import {persistState} from 'redux-devtools';
import DevTools from '../components/DevTools/DevTools';
import reducer from './modules/reducer';

export default function createStore(client, history, data) {
	const middleware = [createMiddleware(client), urlMiddleware(history)];

	let finalCreateStore;
	if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {

		finalCreateStore = compose(
			applyMiddleware(...middleware),
			persistLocalState('cart'),
			window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(),
			persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)),
		)(_createStore);
	} else {
		finalCreateStore = compose(applyMiddleware(...middleware), persistLocalState('cart'))(_createStore);
	}

	const store = finalCreateStore(reducer, data);
	EventEmitter.on('trainingtype.change', () => store.dispatch(dbInfoLoad('trainingType')));

	if (__DEVELOPMENT__ && module.hot) {
		module.hot.accept('./modules/reducer', () => {
			store.replaceReducer(require('./modules/reducer'));
		});
	}

	return store;
}



// WEBPACK FOOTER //
// ./src/redux/create.js